import { Command } from 'commands/Commands';

export class DuplicateBusiness extends Command {
	type: string = 'DuplicateBusiness';
	constructor(public newValue: string[]) {
		super(newValue)
	}
	priority: number = 100;
}